
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      id="page-footer"
      className="bg-white dark:bg-gray-900 dark:text-gray-100"
    >
      <div className="container mx-auto flex flex-col space-y-6 px-4 py-16 text-center text-sm lg:flex-row-reverse lg:space-y-0 lg:px-8 lg:py-32 xl:max-w-7xl">
        <nav className="space-x-4 lg:w-1/3 lg:text-right">
          <Link
            to="https://www.linkedin.com/company/jctechs"
            className="text-gray-400 hover:text-gray-800 dark:hover:text-white"
          >
          <svg width="24px" height="24px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg"><title>LinkedIn icon</title><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>          </Link>
        </nav>

        <nav className="space-x-2 sm:space-x-4 lg:w-1/3 lg:text-center">
          <Link to="/#"
            className="font-medium text-gray-700 hover:text-gray-950 dark:text-gray-400 dark:hover:text-gray-50"
          >
            About
          </Link>

          <Link
            to="/#"
            className="font-medium text-gray-700 hover:text-gray-950 dark:text-gray-400 dark:hover:text-gray-50"
          >
            Terms of Service
          </Link>

          <Link
            to="/#"
            className="font-medium text-gray-700 hover:text-gray-950 dark:text-gray-400 dark:hover:text-gray-50"
          >
            Privacy Policy
          </Link>
        </nav>
        
        <div className="text-gray-500 lg:w-1/3 lg:text-left dark:text-gray-400/80">
          Copyright Ⓒ 2024 JC-TECHS. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}